import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
//import { PurchaseEvents } from './PurchaseEvents';
import { DCService } from "../../../services/index";

@Component({
  selector: "matchingDesignList",
  templateUrl: "./matchingDesignList.html"
})
export class matchingDesignList {
  designColorList = [];
  matchingDesignList = [];
  row: any;
  data: any;
  mode = "Add";
  dcdata: any = { dc_id: "", total_mtr: 0 };
  dcdata1: any;
  designdata: any = { indent_no: 0, totalmtr: 0, totalamt: 0 };
  qualityList: any;N
  colorList: any;
  codeList: any;
  widthList: any[];
  desData: any = {
    totDes: 0
  };
  barcodeList = [];
  rd_season = []
  saveEvent: any;
  agentList: any;
  partyCodeList: any;
  dcList = [
    {
      design_no: "",
      color: "",
      qty: 0,
    }
  ];
  export: boolean = false;
  isLoadMask: Promise<any>;

  page_id: string =
    Math.random()
      .toString(36)
      .substr(2, 9) + "_";

  isLoading = false;
  sampleList = [{ name: "YES" }, { name: "NO" }];
  @Input() _params: any;
  dc_id: any;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    this.getMatchingDesignList()
    this.saveEvent = val["data"].tabevent;
  }

  get params(): any[] {
    return this._params;
  }

  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    private dcService: DCService,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
  ) {
    this.data = {
      dcdata1: []
    };
  }
  ngOnInit() {
    this.partycodelist_season();
    // this.typelist();
    if (this.mode == "Add" || this.mode == 'WorkOrderDc') {
      this.dcdata.dc_date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      this.getAuto();
      this.getRefAuto();
      this.getbarcodeList();
    }
  }
  ngAfterViewInit() {
    setTimeout(() => {
      $("#section").focus();
    }, 100);
  }
  onEnterKeyPressed(nextEl: string, ind, item) {
    if (nextEl == "barcodegood") {
      $("#" + this.page_id + "barcode-0").focus();
    } else {
      $("#" + this.page_id + nextEl).focus();
    }
  }

  onGoToNextFld($event, fld, ind) {
    if (fld == "color") {
      let totdes = 0;
      const designlist = [];
      for (let i = 0; i < this.dcList.length; i++) {
        const design = this.dcList[i].design_no;
        if (design != "") {
          if (designlist.indexOf(design) == -1) {
            designlist.push(design);
            totdes++;
          }
        }
      }
      this.dcdata.total_design = totdes;
    }

    let nxtInd = ind,
      barcode = this.dcList[ind]["lump_no"],
      design = this.dcList[ind]["design_no"],
      color = this.dcList[ind]["color"],
      hsn = this.dcList[ind]["hsn"],
      width = this.dcList[ind]["width"],
      qty = this.dcList[ind]["qty"];

    const nxtRow = $("#row-" + ind).next("tr");
    if (fld == "design" && nxtRow.length == 0) {

      const len = this.dcList.length;
      const lump_no = this.dcList[len - 1]["lump_no"];
      const qty = this.dcList[len - 1].qty;
      nxtInd = nxtInd + 1;
      $("#" + this.page_id + "design" + "-" + nxtInd).focus();

      if (lump_no != "" && nxtInd == len) {
        this.dcList.push({
          design_no: "",
          color: "",
          qty: 0,
        });

        $("#" + this.page_id + "design" + "-" + nxtInd).focus();
      } else if (design == "" && nxtInd == len) {
        const a = nxtInd - 1;
        $("#" + this.page_id + "design" + "-" + a).focus();
      } else {
        $("#" + this.page_id + "design" + "-" + nxtInd).focus();

        return false;
      }
    }

    //   nxtInd = this.designList.length - 1;
    else if (fld == "item_name") {
      const nxtRowID = nxtRow[0].id;
      nxtInd = nxtRowID.split("-")[1];
    } else {
      setTimeout(() => {
        $("#" + this.page_id + fld + "-" + nxtInd).focus();
      }, 200);
    }
  }
  getDesignColor(design_no){
    const colorList = this.barcodeList.filter(el => design_no == el.design_no);
    let designColor1 = colorList.map(el => ({color : el.shade}));
    let designColor2 = colorList.map(el => ({color : el.color}));

    let designColor = designColor1.concat(designColor2);

    this.designColorList = designColor.map(el => el.color)
    .filter((value, index, self) => self.indexOf(value) === index).map(el => ({color : el}));
  }
  onChangeCode(design_no, color, design, ind) {
    // if (barcode.length == 6) {
      const data = this.barcodeList.filter(el => design_no == el.design_no);
      let exists = false;
      for (let i = 0; i < this.dcList.length; i++) {
        const li = this.dcList[i];
        if (i !== ind) {
          if (li.design_no == design_no && li.color == color) {
            exists = true;
            break;
          }
        }
      }
      if (exists) {
        design.design_no = "";
        design.color = "";
        design.qty = "";

        this.toasterService.pop({
          bodyOutputType: 1,
          type: "error",
          title: "Design no and Color Already Exists"
        });
      }

      else if (this.dcdata.userName == "") {
        this.toasterService.pop({
          bodyOutputType: 1,
          type: "error",
          title: "Please Enter your Name"
        });
      } else {

        let totdes = 0;
        const designlist = [];
        for (let i = 0; i < this.dcList.length; i++) {
          const design = this.dcList[i].design_no;
          if (design != "") {
            if (designlist.indexOf(design) == -1) {
              designlist.push(design);
              totdes++;
            }
          }
        }
        this.dcdata.total_design = totdes;

        
        
      }
  }
  onSelectItem($event, design, ind) {
    // debugger;
    const design_no = $event.item.design_no;
    // if (barcode.length == 6) {
      let exists = false;
      for (let i = 0; i < this.dcList.length; i++) {
        const li = this.dcList[i];
        if (i !== ind) {
          if (li.design_no == design_no && li.color == design.color) {
            exists = true;
            break;
          }
        }
      }
      if (exists) {
        design.design_no = "";
        design.color = "";
        design.qty = "";

        this.toasterService.pop({
          bodyOutputType: 1,
          type: "error",
          title: "Design no and Color Already Exists"
        });
      }

      else if (this.dcdata.userName == "") {
        this.toasterService.pop({
          bodyOutputType: 1,
          type: "error",
          title: "Please Enter your Name"
        });
      } else {

        let totdes = 0;
        const designlist = [];
        for (let i = 0; i < this.dcList.length; i++) {
          const design = this.dcList[i].design_no;
          if (design != "") {
            if (designlist.indexOf(design) == -1) {
              designlist.push(design);
              totdes++;
            }
          }
        }
        this.dcdata.total_design = totdes;

        
      }
  }
  getMtrsForColor(design,ind){
    let design_no = design.design_no,color = design.color;
    const data1 = _.filter(this.barcodeList, { design_no: design_no , shade : color });
    const data2 = _.filter(this.barcodeList, { design_no: design_no , color : color });

    const data = data1.concat(data2);

    let totalMtrs = data.map(el => el.mtrs).reduce(function(acc,cur){
      return acc+ cur;
    },0);

    console.log(totalMtrs);
    this.dcList[ind].qty = totalMtrs;

    var exists = this.matchingDesignList.filter(el => el.design_no == design.design_no && el.color == design.color);

    if(exists.length > 0){
      swal("Design no and color already exists in Matching Design List");
      this.dcList[ind].design_no = '';
      this.dcList[ind].color = '';
      this.dcList[ind].qty = 0;
    }


  }
  isRowEmpty(ind) {
    const data = this.dcList;
    for (let i = 0; i < data.length; i++) {
      if (data[i + 1].design_no != "") {
        return true;
      } else {
        return false;
      }
    }
  }
  onDeleteRow($event, fld, ind) {
    $event.preventDefault();
    const that = this;
    swal({
      title: "Are you sure to delete this row?",
      type: "warning",
      focusCancel: true,
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "No, want to change"
    }).then(
      function() {
        if (that.dcList.length > 1) {
          that.dcList.splice(ind, 1);

          if (that.dcdata.type == "Work Order") {
            that.calctot();
          } else {
            let totdes = 0;
            const designlist = [];
            for (let i = 0; i < that.dcList.length; i++) {
              const design = that.dcList[i].design_no;
              if (design != "") {
                if (designlist.indexOf(design) == -1) {
                  designlist.push(design);
                  totdes++;
                }
              }
            }
            that.dcdata.total_design = totdes;
          }

          if ($("#" + this.page_id + fld + "-" + (ind - 1)).length > 0) {
            $("#" + this.page_id + fld + "-" + (ind - 1)).focus();
          } else if ($("#" + this.page_id + fld + "-" + (ind + 1)).length > 0) {
            $("#" + this.page_id + fld + "-" + (ind + 1)).focus();
          }
        }
      },
      function(dismiss) {}
    );
  }

  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }

  getRefAuto() {
    this.dcService.getRefAuto({}).then((res: any) => {
      this.dcdata.ref_no = res;
    });
  }

  getAuto() {
    this.dcService.getdcAuto({}).then((res: any) => {
      this.dcdata.dc_no = res;
    });
  }

  partycodelist_season() {
    this.dcService.partycodelist_season({}).then((res: any) => {
      this.rd_season = res.rd_season;

      if(this.dcdata.type && (this.dcdata.type == 'Sample' || this.dcdata.type == 'Swatch & Sample')){
        if(this.rd_season.length <= 0){
          swal( this.dcdata.type +" entry is not allowed today");
          this.dcdata.type= '';
          // this.typeList = ["Swatch", "Sample", "Others", "Swatch & Sample"];
        }
      }
      
    });
  }

  onClickCode(party_code) {
    const partyCodeList = _.filter(this.codeList, { code: party_code });
    this.dcdata.party_id = partyCodeList[0]["party_id"];
    this.dcdata.party_name = partyCodeList[0]["party_name"];
  }


  getbarcodeList() {
    this.dcService.barcodelist({}).then((res: any) => {
      this.barcodeList = res.data;
      for (let i = 0; i < this.barcodeList.length; i++) {
        this.barcodeList[i].barcode = this.barcodeList[i].barcode
          .toString()
          .padStart(6, "0");
      }
    });
  }



  checkQty(qty, row, ind) {
    this.barcodeList;
    let that = this;
    this.barcodeList.forEach(function(element) {
      if (row.lump_no == element.barcode) {
        if (qty > element.mtrs) {
          that.barcodeList[0].qty = 0;
          that.dcList[ind].qty = 0;
        }
      }
    });
    if (qty > row.qty) {
      this.dcList[ind].qty = 0;
    }
  }
  getMatchingDesignList(): void {
    let params = {
      check : true
       
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.dcService
        .matchingDesignList(params)
        .then(function (res: any) {
            that.matchingDesignList = res.data;
        });
}


  oncheckemptyrow() {
    const design = this.dcList;
    const desList = [];
    for (let i = 0; i < design.length; i++) {
      if (design[i].design_no != "") {
        desList.push(design[i]);
      }
    }
    this.dcList = desList;
    if(this.dcdata.userName){
      this.onSaveOrder();
    }else{
      swal("Please Enter verifier name");
    }
    
  }
  calctot() {
    let totmtr = 0;
    for (let i = 0; i < this.dcList.length; i++) {
      const dcdata = this.dcList[i];
      totmtr += dcdata.qty;
    }

    this.dcdata.total_mtr = totmtr;
  }

  


  onSaveOrder(): void {
    const params: any = Object.assign({}, this.dcdata);
    params["tabevent"] = undefined;
    params["dcList"] = JSON.stringify(this.dcList);
    params["mode"] = this.mode;
    params["dc_date"] = this.datePipe.transform(
      params["dc_date"],
      "yyyy-MM-dd"
    );
    const that = this;
    that.isLoading = true;
    swal({
      title: "Are you sure to save this Matching Designs?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, save it!",
      cancelButtonText: "No, want to change"
    }).then(function() {
      that.isLoading = true;
      that.dcService
        .addUpdateMatchingDesignList(params)
        .then(function(res: any) {
          that.isLoading = false;
          if (that.saveEvent) {
            that.saveEvent.emit();
          }

          if (res.response.success) {
              that.toasterService.pop({
                bodyOutputType: 1,
                type: "success",
                title: "SUCCESS",
                body: res.message
              });

              const tabObj = {
                action: "CloseTab",
                params: {}
              };
              that.tabUpdateEvent.emit(tabObj);
            

          } else {
            swal("ERROR", res.message, "error");
          }

        })
        .catch(function(error: any) {
          that.isLoading = false;
          const res = JSON.parse(error._body);
          swal("ERROR", res.message, "error");
        });
    });
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/matchingDesignList/matchingDesignList.ts